import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "100%" : '55%',
  },
};

export default function EditBoyan({
    editBoyanInfo,
    setEdit,
    edit,
}) {
    const mainTopic = "Boyan";
    const [boyanEditInfo, setBoyanEditInfo] = useState({});
    const [categoryList, setCategoryList] = useState([])

    useEffect(() => setBoyanEditInfo(editBoyanInfo), []);

    useEffect( ()  => {     
      async function fetchData() {   
       const category = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/${mainTopic}`)
       setCategoryList(category.data.response);
      }
      fetchData(); 
    },[])

    const boyanEdit = async (e) => {
        e.preventDefault();
        try {
            const boyanInserted = await axios.put(
              `https://ahlehaqserver.herokuapp.com/api/boyan/${editBoyanInfo._id}`,
              boyanEditInfo
            );
    
            //if request success, will show success notification
            if (boyanInserted.data.code === 200) {
                
              setEdit(false)
              toast.success("Boayn edited successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };
    return (
        <>
         <Modal isOpen={edit} style={customStyles}>
         <h1 className="ml-4">Edit a Boyan</h1>
         <form onSubmit={boyanEdit}>
                      <div className="row">
                         <div className="col-md-6">
                          <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Select category<span className="text-danger">*</span>
                              </label>
                              
                              <select
                                className="form-control rounded"
                                id="exampleInputEmail1"
                                name="category"
                                value={boyanEditInfo?.category || ""}
                                required
                                onChange={(e) =>
                                    setBoyanEditInfo((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value,
                                  }))
                                }
                              >
                                <option>
                                    "Choose from the list"
                                </option>
                                {categoryList &&
                                  categoryList.map((data) => (
                                    <option value={data.category}>
                                      {data.category}
                                    </option>
                                  ))}
                              </select>  
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Boyan Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="example: AF4SE3250"
                              id="exampleInputPassword1"
                              name="title"
                              value={boyanEditInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setBoyanEditInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                              Video url <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              id="exampleInputPassword1"
                              name="videoUrl"
                              value={boyanEditInfo?.videoUrl || ""}
                              required
                              placeholder="Example: https://example.com"
                              onChange={(e) =>
                                setBoyanEditInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>
                          
                         <div className="col-md-12">
                            <CKEditor
                                editor={ ClassicEditor }
                                data={boyanEditInfo?.description || ""}
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setBoyanEditInfo((Prev) => ({ ...Prev, description: data }))
                                  
                                } }
                            />
                         </div>  
                          
                         <div className="col-md-6">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                              <button
                                className="btn btn-danger rounded-pill px-4 ml-3"
                                onClick={() => setEdit(false)}
                                >
                                Close
                                </button>
                            </div>  
                         </div> 

                      </div>

                    </form>
         </Modal>   
        </>
    )
}
